import { PHOTO_URL } from './apiutils'

/**
 * 商品圖片網址組合。
 *
 * 資料庫存的是相對路徑（例：/products/xxxx.jpg），不是完整網址，
 * 直接丟給 <img src> 會破圖。既有的 InventoryProductCard 已經有
 * 同樣的邏輯，這裡收斂成共用函式，新頁面一律用這支。
 */

/** 舊資料裡有些是 placeholder 服務的網址，那些等同沒有圖 */
const isPlaceholder = (url) =>
  !url ||
  url.includes('via.placeholder.com') ||
  url.toLowerCase().includes('placeholder')

/**
 * @param {string} path 資料庫中的圖片路徑或完整網址
 * @param {string} [fallback] 沒有圖片時的回傳值，預設空字串
 * @returns {string}
 */
export function getProductImageUrl (path, fallback = '') {
  if (!path) return fallback
  const full =
    path.startsWith('http://') || path.startsWith('https://')
      ? path
      : `${PHOTO_URL}${path}`
  return isPlaceholder(full) ? fallback : full
}
